/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with the key factory*/
import { useQuery } from "@tanstack/react-query";

import { tillsKeys } from "../keys";
import { getTill } from "../requests";

export function useTill(id: string | undefined) {
  return useQuery({
    queryKey: tillsKeys.detail(id ?? "unknown"),
    queryFn: () => {
      if (!id) {
        throw new Error("Till ID is required");
      }
      return getTill(id);
    },
    enabled: Boolean(id)
  });
}
